var Aneox;
(function (Aneox) {
  'use strict';

  var Vintages = (function () {

    var animations;
    var locale;
    var scroll;
    var self;

    var vintagesTextElement;
    var vintagePageElement;
    var vintagePhotoElement;
    var vintagePageTextElement;
    var vintageTitleYearElement;
    var vintageWrapper;
    var vintageDownloadButton;

    var currentVintage = null;
    var currentSet = 0;
    var nbSets;
    

    function Vintages(anims, lang, scrolling) {
      animations = anims;
      locale = lang;
      scroll = scrolling;
      self = this;

      vintagesTextElement = $('#vintages-text');
      vintagePageElement = $('#vintage');
      vintagePhotoElement = $('#vintage-photo');
      vintagePageTextElement = $('#vintage-page-text');
      vintageTitleYearElement = $('#vintage-title-year');
      vintageWrapper = $('#vintage-wrapper');
      vintageDownloadButton = $('#vintage-download');

      //nbSets = Math.ceil(Aneox.Data.Data.vintages.length / 3);
      //nbSets = Math.ceil(app.dataVintages / 3);

      // locale.bind('localeChange', function(locale) {
      //   vintagesTextElement.empty();
      //   self.populateInlineSection(locale);
      // });
    }

    Vintages.prototype.openPage = function(id) {
      currentVintage = +id;
      scroll.incrementScrollRetainCount();
      populatePage(id, locale.getLocale());
      animations.openOverlay(vintagePageElement);
      new TimelineMax()
      .add(animations.PageBorderTimeline($('#vintage-borders')), 2)
      .from('#vintage-photo', 1, {
        scale: 1.1
      }, 2)
      .add(animations.SubtitleTimeline($('#vintage-title')), 2.5)
      .add(animations.TextTimeline($('#vintage-content')), 2.7);
    };

    Vintages.prototype.closePage = function() {
      currentVintage = null;
      animations.closeOverlay(vintagePageElement, emptyPage);
      scroll.decrementScrollRetainCount();
    }

    /*function populateInlineSection(locale) {
      var fragment = $(document.createDocumentFragment());
      var dataVintage = app.dataVintages;
        console.log("Vintage");
        console.log(animations);
        console.log(dataVintage);
        
        
      Aneox.Data.Data.vintages.forEach(function(vintage) {
        var vintageLocale = _.find(vintage.locales, { locale: locale });
        var li = $('<li class="vintage-intro text-center">' +
          '<h3 class="vintage-inline-title">' +
            '<span class="line-wrapper"><span class="line">' +
              (locale === 'fr' ? 'Millésime' : 'Vintage') +
            '</span></span>' +
            '<span class="vintage-inline-year handwriting line-wrapper">' +
              '<span class="line">' + vintage.id + '</span>' +
            '</span>' +
            '<span class="hr"></span>' +
          '</h3>' +
          '<p>' + vintageLocale.summary + '</p>' +
        '</li>');
        var button = $('<button class="button-discover">');
        button.on('click', function() {
          self.openPage(vintage.id);
        })
        .text(locale === 'fr' ? 'Découvrir' : 'Discover')
        .appendTo(li);
        fragment.append(li);
      });

      if (Aneox.Data.Data.vintages.length % 3 !== 0) {
        fragment.append('<li class="vintage-quotation vintage-intro text-center">' +
          Aneox.Data.Data['vintage-quote'][locale] +
        '</li>');
      }

      vintagesTextElement.html(fragment);
    }*/

    function populatePage(id, locale) {
        
    nbSets = Math.ceil(app.dataVintages / 3);    
        
      var vintage = _.find(app.dataVintages, { id: id });
      var vintageLocale = _.find(vintage.locales, { locale: locale });  
        
      vintageDownloadButton.attr('href', 'pdf/vintage/' + vintageLocale.nid );

      //var vintage = _.find(Aneox.Data.Data.vintages, { id: id });
      
      vintageTitleYearElement.text(vintage.name);
      //vintageTitleYearElement.text(vintage.id);
      vintagePhotoElement.attr('data-bg', vintage.img)
      .removeClass('lazyloaded').addClass('lazyload');
      //vintagePageTextElement.html(vintageLocale.text);
      vintagePageTextElement.html(vintageLocale.text);

      vintagePageTextElement.mCustomScrollbar({
        scrollbarPosition: 'outside',
        scrollButtons: {
          enable: true,
          scrollType: 'stepped',
          scrollAmount: 200
        },
        callbacks: {
          onInit: function() {
            $(this).find('.mCSB_buttonUp').addClass('disabled');
          },
          onScroll: function() {
            if (this.mcs.topPct === 0) {
              $(this).find('.mCSB_buttonUp').addClass('disabled');
              $(this).find('.mCSB_buttonDown').removeClass('disabled');
            } else if (this.mcs.topPct === 100) {
              $(this).find('.mCSB_buttonDown').addClass('disabled');
              $(this).find('.mCSB_buttonUp').removeClass('disabled');
            } else {
              $(this).find('.mCSB_buttonUp, .mCSB_buttonDown').removeClass('disabled')
            }
          }
        }
      });
    }

    function emptyPage() {
      vintagePageTextElement.mCustomScrollbar('destroy').empty();
    }

    function switchVintage(id) {
      vintagePageTextElement.mCustomScrollbar('destroy')
      .css('overflow', 'hidden');
      var vintageWrapperTemp = vintageWrapper.clone()
      .attr('id', 'vintage-wrapper-temp')
      .insertAfter(vintageWrapper);
      vintageWrapper.css('opacity', 0);

      populatePage(id, locale.getLocale());

      TweenMax.to(vintageWrapper, .5, { opacity: 1 });
      TweenMax.to(vintageWrapperTemp, .5, {
        opacity: 0,
        onComplete: function() {
          vintageWrapperTemp.remove();
        }
      });
    }
      
    Vintages.prototype.populateInlineSection = function(locale){
    
     locale = locale;
     nbSets = Math.ceil(app.dataVintages.length / 3);   
     vintagesTextElement.empty();
        
      var fragment = $(document.createDocumentFragment());

      if (app.dataVintages.length > 2) {
        $('.vintages-button-switch').show();
      }

      if (app.dataVintages.length % 3 !== 0) {
        fragment.append('<li class="vintage-quotation vintage-intro text-center active">' +
          Aneox.Data.Data['vintage-quote'][locale] +
        '</li>');
      }    
        
      app.dataVintages.forEach(function(vintage, index) {
        var vintageLocale = _.find(vintage.locales, { locale: locale });
          
        var li = $('<li class="vintage-intro text-center' + (index < 2 ? ' active' : '') + '">' +
          '<h3 class="vintage-inline-title">' +
            '<span class="line-wrapper"><span class="line">' +
              (locale === 'fr' ? 'Millésime' : 'Vintage') +
            '</span></span>' +
            '<span class="vintage-inline-year handwriting line-wrapper">' +
              '<span class="line">' + vintage.name + '</span>' +
            '</span>' +
            '<span class="hr"></span>' +
          '</h3>' +
          '<p>' + vintageLocale.summary + '</p>' +
        '</li>');
        var button = $('<button class="button-discover">');
        button.on('click', function() {
          self.openPage(vintage.id);
        })
        .text(locale === 'fr' ? 'Découvrir' : 'Discover')
        .appendTo(li);
        fragment.append(li);
      });        

      vintagesTextElement.html(fragment);
    }

    Vintages.prototype.next = function() {
      if (_.findIndex(app.dataVintages, { id: '' + currentVintage }) === 0) {
        currentVintage = +app.dataVintages[app.dataVintages.length - 1].id;
      } else {
        currentVintage++;
      }
      switchVintage('' + currentVintage);
    };

    Vintages.prototype.previous = function() {
      if (_.findIndex(app.dataVintages, { id: '' + currentVintage }) ===
        app.dataVintages.length - 1)   {
        currentVintage = +app.dataVintages[0].id;
      } else {
        currentVintage--;
      }
      switchVintage('' + currentVintage);
    }

    Vintages.prototype.nextSet = function() {
      currentSet++;
      if (currentSet >= nbSets) {
        currentSet = 0;
      }
      $('.vintage-intro').removeClass('active');
      $('.vintage-intro:nth-child(n+' + (currentSet * 3 + 1) +
        '):nth-child(-n+' + ((currentSet+1) * 3) + ')').addClass('active');
    };

    Vintages.prototype.previousSet = function() {
      currentSet--;
      if (currentSet < 0) {
        currentSet = nbSets - 1;
      }
      $('.vintage-intro').removeClass('active');
      $('.vintage-intro:nth-child(n+' + (currentSet * 3 + 1) +
        '):nth-child(-n+' + ((currentSet+1) * 3) + ')').addClass('active');
    };

    return Vintages;
  })();

  Aneox.Vintages = Vintages;
})(Aneox || (Aneox = {}));